module.exports = __webpack_public_path__ + "img/volkswagen-financial-services-logo.799d15b5.png";